/* ==========================================================================
   AutocompleteRxjs > Client > Services
   ========================================================================== */

/* Modules */
const { of } = require('rxjs');
const { catchError, switchMap } = require('rxjs/operators');
const { fromFetch } = require('rxjs/fetch');

const BORG_ENDPOINT = '//autocomplete.toolfactory.tech/query';

/* Global variables for AbortController */
let controller;

/* Exports */
module.exports = function Services(config = {}) {
    /* Data */
    const { geolocation = false, max = 20, types = [], context, operator, codes = [] } = config;
    const { language } = context;

    /* Cancel the previous request */
    if (controller !== undefined) {
        controller.abort();
    }

    /* Feature detect */
    if ('AbortController' in window) {
        controller = new AbortController();
    }

    /**
     * Get suggestions
     * Params documentation:
     * q: query string to took for
     * f: format
     * g: boolean to include geolocation data
     * n: maximum number of suggestions
     * l: language
     * t: list of types
     * o: list of [codes]
     * p: operator "OR/AND"
     *
     * @param {string} text to look for in borg
     * @returns {JSON} data
     */
    function getSuggestions(text = '') {
        /* Build url */
        const url = BORG_ENDPOINT.concat(
            '?',
            `q=${text}`,
            `&f=json`,
            `&g=${geolocation}`,
            `&n=${max}`,
            `&l=${language}`,
            `&t=${types.join(',')}`,
            operator ? `&p=${operator}` : '',
            codes.length ? `&o=${codes.map(code => code)}` : ''
        ).trim();

        return fromFetch(url, {
            signal: controller.signal,
            credentials: 'same-origin',
            cache: 'no-store'
        }).pipe(
            switchMap(response => {
                if (response.ok) {
                    return response.json();
                }
                return of({ error: true, message: `Error fetching results in borg ${response.statusText}` });
            }),
            catchError(err => of({ error: true, message: err.message }))
        );
    }

    return {
        getSuggestions
    };
};
